// src/pages/UserManagementPage.jsx
import React, { useEffect, useState } from "react";

function UserManagementPage() {
    const [users, setUsers] = useState([]);

    useEffect(() => {
        // Example: fetch from backend
        // fetch("/api/users")
        //   .then((res) => res.json())
        //   .then((data) => setUsers(data));

        // For demo, use mock data:
        setUsers([
            { id: 1, name: "Alice", status: "active" },
            { id: 2, name: "Bob", status: "inactive" },
            { id: 3, name: "Charlie", status: "active" },
        ]);
    }, []);

    return (
        <div>
            <h1 className="text-2xl font-bold mb-4">User Management</h1>
            <div className="bg-white rounded shadow p-4">
                <table className="w-full">
                    <thead>
                        <tr className="border-b">
                            <th className="p-2 text-left">ID</th>
                            <th className="p-2 text-left">Name</th>
                            <th className="p-2 text-left">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user) => (
                            <tr
                                key={user.id}
                                className="border-b hover:bg-gray-50">
                                <td className="p-2">{user.id}</td>
                                <td className="p-2">{user.name}</td>
                                <td className="p-2">{user.status}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default UserManagementPage;
